var _defs, _path, _polygon, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SolderingIron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9qeVFAF8hATSFak~MRQ7Va",
    x1: 41.457,
    x2: 31.962,
    y1: 2.543,
    y2: 12.038,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 14",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    stopColor: "#dfe9f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#d6e0e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#bfc8d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#889097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9qeVFAF8hATSFak~MRQ7Vb",
    x1: 37.368,
    x2: 20.195,
    y1: 6.632,
    y2: 23.805,
    xlinkHref: "#9qeVFAF8hATSFak~MRQ7Va"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9qeVFAF8hATSFak~MRQ7Vc",
    x1: 9.546,
    x2: 20.95,
    y1: 10.014,
    y2: 41.347,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 121",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M12.30859,44.8457A6.91911,6.91911,0,0,1,7.293,42.707a4.72791,4.72791,0,0,1-1.231-4.34375A8.03552,8.03552,0,0,1,8.293,34.293.99989.99989,0,0,1,9.707,35.707a5.99928,5.99928,0,0,0-1.67871,3.02051A2.78944,2.78944,0,0,0,8.707,41.293c3.96143,3.96094,10.11768-.53418,14.58594-5,6.75635-6.75684,12.03271-5.60059,13.98584-4.793C39.46973,32.4082,41,34.25781,41,36a1,1,0,0,1-2,0c0-.79687-.93018-2.00684-2.48682-2.65234-1.58349-.6543-5.9038-1.543-11.80615,4.35937C19.34863,43.06543,15.30957,44.8457,12.30859,44.8457Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#9qeVFAF8hATSFak~MRQ7Va)",
    points: "34.832 10.582 33.418 9.168 38.043 4.543 40 4 39.457 5.957 34.832 10.582"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#9qeVFAF8hATSFak~MRQ7Vb)",
    d: "M21.41406,25.41406l-2.82812-2.82812L33.87883,7.293a1,1,0,0,1,1.41421,0L36.707,8.707a1,1,0,0,1,0,1.41421Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M21.00368,18.46079h5.07107a1,1,0,0,1,1,1v3a0,0,0,0,1,0,0H20.00368a0,0,0,0,1,0,0v-3a1,1,0,0,1,1-1Z",
    transform: "rotate(45 23.54 20.46)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#9qeVFAF8hATSFak~MRQ7Vc)",
    d: "M25.33563,23.33557l-4.67126-4.6712a2.2686,2.2686,0,0,0-3.77246.937l-.82227,2.67224L8.17139,30.17188a3.99992,3.99992,0,1,0,5.65722,5.65625l7.89777-7.89777,2.67224-.82227A2.26867,2.26867,0,0,0,25.33563,23.33557Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SolderingIron);
export default __webpack_public_path__ + "static/media/icons8-soldering-iron.13b372b7be7286e9a80086a141473042.svg";
export { ForwardRef as ReactComponent };